<template>
  <vx-card style="background-color: #9c64b0;">
    <div class="text-center mb-4">
      <h2 class="text-white">{{ header_name }}</h2>
    </div>

    <div class="vx-card__collapsible-content vs-con-loading__container flex items-center justify-center">
      <div class="vx-row w-full justify-center">
        <div class="vx-col lg:w-3/12 md:w-1/2 sm:w-1/2 w-full xl:ml-auto">
          <datepicker v-model="dateFilter" :disabledDates="disabledDates" class="w-full mb-4" :minimumView="'day'"
                      :maximumView="'month'" :language="languages[language]" format="d MMMM yyyy"></datepicker>
        </div>
        <div class="vx-col lg:w-3/12 md:w-1/2 sm:w-1/2 w-full">
          <flat-pickr v-model="timeFilter" class="w-full mb-4" :config="configDateTimePicker"/>
        </div>
        <div class="vx-col lg:w-4/12 md:w-1/2">
          <vs-button class="mr-2" color="success" type="gradient" id="filter-aqi" @click="filterAQI">ค้นหา</vs-button>
          <vs-button color="warning" type="gradient" id="filter-aqi-now" @click="getDateTime">แสดงข้อมูลปัจจุบัน
          </vs-button>
          <!--            <vs-button color="danger" @click="$store.dispatch('map/fetchTest')">Test token path</vs-button>-->
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'

export default {
  components: {
    Datepicker,
    flatPickr
  },
  data: () => ({
    dateFilter: null,
    language: 'th',
    languages: lang,
    timeFilter: null,
    configDateTimePicker: {
      enableTime: true,
      enableSeconds: false,
      noCalendar: true,
      time_24hr: true
    },
    refreshPage: true,
    disabledDates: {// Disable all dates up to specific date
      from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() + 1) // Disable all dates after specific date
    }
  }),
  methods: {
    getDateTime() {
      this.openLoadingInDiv()
      this.dateFilter = new Date()
      this.timeFilter = moment().format('HH:mm')
      let date = moment(String(this.dateFilter)).format('yyyy-MM-DD')
      let dateNum = moment(String(this.dateFilter)).format('DD')
      let monthNum = moment(String(this.dateFilter)).format('MM')
      let yearNum = moment(String(this.dateFilter)).format('yyyy')
      let time = this.timeFilter
      this.$root.$emit('filterAQI', {date: date, time: time})
      let route_params = this.$route.params.id
      if (!route_params) {
        this.$store.commit('map/SET_DATE_FILTER', date,time)
        this.$root.$emit('setClockString', {date: dateNum, time: time, year: yearNum, month: monthNum})
      }

      this.closeLoadingInDiv(2500)
    },
    filterAQI() {
      this.openLoadingInDiv()
      this.refreshPage = false
      let date = moment(String(this.dateFilter)).format('yyyy-MM-DD')
      let dateNum = moment(String(this.dateFilter)).format('DD')
      let monthNum = moment(String(this.dateFilter)).format('M')
      let yearNum = moment(String(this.dateFilter)).format('yyyy')
      let time = this.timeFilter
      this.$root.$emit('filterAQI', {date: date, time: time,})
      let route_params = this.$route.params.id
      let filter_DateTime = new Date(date + 'T' + time)
      let now = new Date()
      if (filter_DateTime <= now && !route_params) {
        this.$store.commit('map/SET_DATE_FILTER', date,time)
        this.$root.$emit('setClockString', {fullDate:date,date: dateNum, time: time, year: yearNum, month: monthNum})
      }
      this.closeLoadingInDiv(2500)
    },
    openLoadingInDiv() {
      setTimeout(() => {
        this.$vs.loading({
          container: '#div-with-loading',
          scale: 0.6
        })
      }, 10)
    },
    closeLoadingInDiv(time) {
      setTimeout(() => {
        this.$vs.loading.close('#div-with-loading > .con-vs-loading')
      }, time);
    }
  },
  created() {
    this.getDateTime()
  },
  computed: {
    header_name() {
      return this.$store.state.air_quality_header.header_name
    }
  },
  mounted() {
    let route_params = this.$route.params.id
    if (this.refreshPage) {
      setInterval(() => this.getDateTime(), 180000)
    }
  }
}
</script>
